import React from 'react';
import { Input, inputSizes } from 'components/styled-primitives';
import { validateSeatCount } from 'utils/validators';

import { Label, InputContainer } from '../../components';

interface SharedMaxSeatStorageManagerProps {
  onChange: (value: string) => void;
  sharedSeatCount?: string | number;
}

const SharedMaxSeatStorageManager = ({
  onChange,
  sharedSeatCount,
}: SharedMaxSeatStorageManagerProps): React.JSX.Element => (
  <InputContainer>
    <Label>Shared Seat Capacity (Max Shared Computers)</Label>
    <Input
      size={inputSizes.MD}
      placeholder="Shared Computer Seats"
      height={30}
      onChange={onChange}
      value={sharedSeatCount}
      validator={validateSeatCount.validator}
      getValidationMessage={validateSeatCount.getValidationMessage}
    />
  </InputContainer>
);

export default SharedMaxSeatStorageManager;
